import React from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from 'v-c/LoadingIndicator';
import displayName from 'component-lib/displayName';
import styles from './Modals.scss';

function ModalContainer({ isProcessing, processingText, children, dataTags }) {
    return (<div
        className={styles['modal-container']}
        data-modal={dataTags['data-modal']}
    >
        <div className={styles['modal-overlay']} />
        <div className={styles.modal}>
            <LoadingIndicator
                isLoading={isProcessing}
                useOverlay
                text={processingText}
            />
            {children}
        </div>
    </div>)
}

ModalContainer.displayName = displayName('Modals/ModalContainer');

ModalContainer.propTypes = {
    children: PropTypes.node.isRequired,
    isProcessing: PropTypes.bool,
    processingText: PropTypes.string,
    dataTags: PropTypes.object,
};

ModalContainer.defaultProps = {
    isProcessing: false,
    processingText: 'Processing...',
    dataTags: {
        'data-modal': true,
    },
};

export default ModalContainer;
